import * as React from "react";

/**
 * Name a row's control from the row's own label.
 *
 * A settings or property row draws its label as a sibling of the control, not
 * as a `<label>` around it — so a Switch, a ToggleGroup or a bare Input on the
 * trailing edge has no text of its own and announces unnamed. This hands the
 * label's element id to the single control the row hosts. A control that
 * already carries a name keeps it, and anything that is not one element (a
 * value read-out split across nodes, a fragment) passes through untouched.
 */
export function labelControl(
  children: React.ReactNode,
  labelId: string,
): React.ReactNode {
  if (!React.isValidElement<Record<string, unknown>>(children)) return children;
  const props = children.props;
  if (props["aria-label"] != null || props["aria-labelledby"] != null) {
    return children;
  }
  return React.cloneElement(children, { "aria-labelledby": labelId });
}
